import { render, staticRenderFns } from "./WeexProgress.vue?vue&type=template&id=4de7b4d2&"
import script from "./WeexProgress.vue?vue&type=script&lang=js&"
export * from "./WeexProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/mifos-vue-uat/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VProgressCircular,VProgressLinear})
